<template lang="pug">

  section.box
    h1(data-aos="fade-right" data-aos-delay="300" data-aos-once="true") BOX
    .video(data-aos="fade-right" data-aos-delay="300" data-aos-once="true")
      Video(src="//rudo.video/vod/bGd04P/autostart/false")
    .text.text1(data-aos="fade-right" data-aos-delay="300" data-aos-once="true")
      Texto
        h2 Las nuevas protagonistas del box
        h4 “Está obsoleto decir que el box es para hombres. Este es un deporte del cuál las mujeres podemos disfrutar y ser protagonistas”.

        p Técnica, rigor, coordinación, disciplina y seguridad son algunas de las características que desarrolla el box. Es uno de los deportes más completos que hay y que cada vez gana más adeptas. Es que su mayor poder es que rompe esquemas y ya dejó atrás el estereotipo de ser una disciplina ruda, hecha para hombres, y ahora son muchas las mujeres que destacan y vibran con el box.

        p El equipamiento es clave y Skechers así lo entiende. Es por esto, que para acompañar a las mujeres en este deporte, Skechers suma adicionalmente a su línea de zapatillas deportivas, su nueva línea de ropa deportiva con diseños y colores que no te dejarán indiferente, especialmente por su calce y comodidad para entregar lo mejor de cada una sobre el ring. Es así como Skechers te acompaña en todas las rutinas deportivas con la comodidad de siempre, lo que facilita la práctica de deportes de alta destreza física como es el box.
    .pic-big(data-aos="fade-right" data-aos-delay="300" data-aos-once="true")
      Gal(:pics="['assets/images/box/01.jpg', 'assets/images/box/02.jpg']")
    .gal(data-aos="fade-right" data-aos-delay="300" data-aos-once="true")
      Gal(:pics="['assets/images/box/03.jpg', 'assets/images/box/04.jpg']")
    .text2(data-aos="fade-right" data-aos-delay="300" data-aos-once="true")
      Texto
        h2 Una deportista destacada
        p Desde hace un año y medio que Ángela Maluk se dedica al box, tras descubrirlo por sorpresa cuando sus amigas la invitaron a una clase de prueba. ¿Qué pasó? Ángela quedó encantada con este deporte e invita a más mujeres para que disfruten de este tipo de actividad física.

        p “En un comienzo tenía un poco de susto y otros prejuicios. Trabajo como modelo, y no puedo tener un moretón en cara”, comenta Ángela Maluk. Sin embargo, se dio cuenta que nada de eso iba a pasar y que podía disfrutar completamente del box. “Las mujeres trabajamos solamente la zona media, entonces no nos golpeamos a la cara y eso es fundamental”, agrega.

        p Ella opina que cada vez más se está convirtiendo en un deporte más femenino. “Está obsoleto decir que el box es para hombres. Este es un deporte del cuál las mujeres podemos disfrutar y ser protagonistas”, enfatiza. Además, destaca que lo que más le gusta es el combate uno y uno, ya que es un deporte que requiere de mucha técnica, coordinación y finalmente te hace sentir más segura, te entrega confianza en el día a día.

        blockquote “El box es un deporte que requiere de mucha técnica, coordinación y finalmente te sientes mucho más segura de ti misma, te da mucha seguridad en el día a día”.

        p Encuentra todos sus modelos en tiendas Skechers y <a href="https://www.skechers.cl">Skechers.cl</a>

</template>

<script>
  import Texto from '@/components/skechers/Texto'
  import Pic from '@/components/skechers/Pic'
  import Gal from '@/components/skechers/Gal'
  import Video from '@/components/skechers/Video'

  export default  {
    name: 'box',
    props: [],
    components: {
      Texto,
      Pic,
      Gal,
      Video
    },
    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {

    },
    computed: {

    }
}
</script>

<style scoped lang="scss">

  h1{
    color: #fb2850;
    text-transform: uppercase;
    font-family: 'AvantGarde';
    @include fluid-type(360px, 1440px, 70px, 224px);
    line-height: 90%;
    padding: 0;
    margin: 2rem 0;
    grid-column: 1 / 6;
    position: relative;
    z-index: 2;
    text-align: center;
    &:after,
    &:before{
      content: '';
      position: absolute;
      height: 30px;
      width: 170px;
      background-color: #fb2850;
      @media screen and (max-width: 700px){
        height: 10px;
        width: 80px;
      }
    }
    &:after{
      bottom: calc(100% - 0.5rem);
      right: 0;
      @media screen and (max-width: 700px){
        bottom: calc(100% + 0.5rem);
      }
    }
    &:before{
      top: calc(100% - 0.5rem);
      left: 0;
      @media screen and (max-width: 700px){
        top: calc(100% + 0.5rem);
      }
    }
  }

  .box {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    width: 100%;
    grid-gap: 1rem;
    @media screen and (max-width: 700px){
      padding: 0 1rem;
    }
  }

  .text1{
    grid-column: 2 / 6;
    @media screen and (max-width: 700px){
      grid-column: 1 / -1;
    }
  }

  .pic-big{
    grid-column: 7 / -1;
    margin-top: 0;
    @media screen and (max-width: 700px){
      grid-column: 1 / -1;
      // display: none;
    }
  }

  .gal{
    grid-column: 2 / 6;
    @media screen and (max-width: 700px){
      grid-column: 1 / -1;
      // display: none;
    }
  }
  .video {
    grid-column: 1 / -1;
  }
  .text2{
    grid-column: 7 / -2;
    @media screen and (max-width: 700px){
      grid-column: 1 / -1;
    }
  }
  h2{
    margin-bottom: 1rem;
  }

  blockquote{
    font-size: 2rem;
    line-height: 150%;
    padding: 2rem;
    background-color: black;
    color: #fb2850;
  }

</style>
